import _ from 'lodash';
import { vault } from '../../actions/actionTypes';
const initialState = { home: {} };
export default function (state = initialState, action) {
    switch (action.type) {
        case vault.FETCH_PHOTOS:
            const fetchPhotosPayload = action.payload;
            const photos = fetchPhotosPayload.photos.filter((item) => item.type.includes('image') || item.type.includes('video'));
            if (fetchPhotosPayload.refresh || fetchPhotosPayload.firstFetch) {
                return {
                    ...state,
                    [fetchPhotosPayload.albumId]: _.mapKeys(photos, 'timestamp'),
                };
            }
            if (fetchPhotosPayload.newUpload) {
                return {
                    ...state,
                    [fetchPhotosPayload.albumId]: {
                        ..._.mapKeys(photos, 'timestamp'),
                        ...state[fetchPhotosPayload.albumId],
                    },
                };
            }
            return {
                ...state,
                [fetchPhotosPayload.albumId]: {
                    ...state[fetchPhotosPayload.albumId],
                    ..._.mapKeys(photos, 'timestamp'),
                },
            };
        case vault.DELETE_PHOTO_FILE:
            const deletePhotoFilePayload = action.payload;
            delete state.home[deletePhotoFilePayload.timestamp];
            return { ...state };
        case vault.LOGOUT_PHOTOS:
            return initialState;
        default:
            return state;
    }
}
